import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  SalesState,
  CreateSalesOrderPayload,
  SalesOrder,
} from "src/types/sales.types";

const initialState: SalesState = {
  salesList: {
    loading: false,
    data: null,
    error: null,
  },
  createSaleOrder: {
    loading: false,
    data: null,
    error: null,
  },
  editSaleOrder: {
    loading: false,
    data: null,
    error: null,
  },
};

const salesSlice = createSlice({
  name: "sales",
  initialState,
  reducers: {
    // 📋 List Sales Orders
    getSalesListRequest: (
      state,
      action: PayloadAction<{
        page: number;
        limit: number;
        createdBy?: string;
      }>
    ) => {
      state.salesList.loading = true;
      state.salesList.error = null;
    },
    getSalesListSuccess: (state, action: PayloadAction<any>) => {
      state.salesList.loading = false;
      state.salesList.data = action.payload;
    },
    getSalesListError: (state, action: PayloadAction<string>) => {
      state.salesList.loading = false;
      state.salesList.error = action.payload;
    },

    // 💰 Create Sales Order
    createSalesOrderRequest: (
      state,
      action: PayloadAction<CreateSalesOrderPayload>
    ) => {
      state.createSaleOrder.loading = true;
      state.createSaleOrder.error = null;
    },
    createSalesOrderSuccess: (state, action: PayloadAction<SalesOrder>) => {
      state.createSaleOrder.loading = false;
      state.createSaleOrder.data = action.payload;
    },
    createSalesOrderError: (state, action: PayloadAction<string>) => {
      state.createSaleOrder.loading = false;
      state.createSaleOrder.error = action.payload;
    },

    // ✏️ Edit Sales Order
    editSalesOrderRequest: (
      state,
      _action: PayloadAction<{ id: string; data: CreateSalesOrderPayload }>
    ) => {
      state.editSaleOrder.loading = true;
      state.editSaleOrder.error = null;
    },
    editSalesOrderSuccess: (state, action: PayloadAction<SalesOrder>) => {
      state.editSaleOrder.loading = false;
      state.editSaleOrder.data = action.payload;
    },
    editSalesOrderError: (state, action: PayloadAction<string>) => {
      state.editSaleOrder.loading = false;
      state.editSaleOrder.error = action.payload;
    },

    resetSalesList: (state) => {
      state.salesList = { loading: false, data: null, error: null };
    },
    resetCreateSalesOrder: (state) => {
      state.createSaleOrder = { loading: false, data: null, error: null };
    },
    resetEditSalesOrder: (state) => {
      state.editSaleOrder = { loading: false, data: null, error: null };
    },
  },
});

export const {
  getSalesListRequest,
  getSalesListSuccess,
  getSalesListError,
  createSalesOrderRequest,
  createSalesOrderSuccess,
  createSalesOrderError,
  editSalesOrderRequest,
  editSalesOrderSuccess,
  editSalesOrderError,
  resetSalesList,
  resetCreateSalesOrder,
  resetEditSalesOrder,
} = salesSlice.actions;

export default salesSlice.reducer;
